export default __webpack_public_path__ + "static/media/try-it-for-free.857e57f0.mp3";